import React from 'react';
import { Table, Tag, message, Row, Col, Card, Spin, DatePicker, Modal, Select, Descriptions, Button, Space, Input, Tooltip, Typography } from 'antd';
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { fetchCampOffAttendance, updateCampoffData } from '../../utils/API';
interface CampassoffPage {
    date: any;
    userId: any;
    _id: string;
    key: string;
    attendanceId: {
        _id: string;
        userId: {
            _id: string;
            username: string;
        };
        username?: string;
        date: string;
        day: string;
        clockIn: string;
        lunchStart: string;
        lunchEnd?: string;
        endTime?: string;
        requestStatus?: string;
        lunchComplete: string;
        clockOut: string;
        totalTime: string;
        highlightRed?: boolean;
        status: 'Present' | 'Absent' | 'Late' | 'On Leave' | 'CampOff' | string | any;
    };
    updatedData?: {
        clockIn?: string;
        lunchStart?: string;
        lunchEnd?: string;
        clockOut?: string;
    };
    photo?: string;
    adminResponse?: string;
    status?: string | any;
}

interface CampusaprovemodalProps {
    visible: boolean;
    onClose: () => void;
    onSuccess?: () => void;
    customerId?: string;
    record: CampassoffPage | null | undefined | any;
}

export const Campusaprovemodal: React.FC<CampusaprovemodalProps> = ({
    visible,
    onClose,
    onSuccess,
    customerId,
    record
}) => {
    const [isLoading, setIsLoading] = React.useState(false);
    const [selectedRecord, setSelectedRecord] = useState<CampassoffPage | null>(null);
    const [currentRecord, setCurrentRecord] = useState<CampassoffPage | undefined>(undefined);

    const [attendanceData, setAttendanceData] = useState<any>(null);
    const [remark, setRemark] = useState<string>("");

    const statusStyles = {
        Present: {
            background: "#dcfce7",
            text: "#15803d",
        },
        Absent: {
            background: "#fee2e2",
            text: "#b91c1c",
        },
        HalfDay: {
            background: "#dbeafe",
            text: "#1d4ed8",
        },
        Leave: {
            background: "#fef9c3",
            text: "#ca8a04",
        },
        Sunday: {
            background: "#ede9fe",
            text: "#7c3aed",
        },
        Holiday: {
            background: "#fce7f3",
            text: "#db2777",
        },
        WeekOff: {
            background: "#ffedd5",
            text: "#ea580c",
        },
        HalfLeave: {
            background: "#dcfce7",
            text: "#15803d",
        },
        Approved: {
            background: "#e0f2fe",
            text: "#0284c7",
        },

    };
    useEffect(() => {
        if (visible && record) {
            // Set the current record immediately when modal opens
            setCurrentRecord(record);

            // Then fetch additional data if needed
            fetchAttendanceData(record);
        }
    }, [visible, record]);


    const fetchAttendanceData = async (record: CampassoffPage) => {
        try {
            setIsLoading(true);

            // Make sure we have the necessary data in the record
            if (!record?.userId?._id) {
                message.warning("Incomplete record data");
                return;
            }

            const userId = record.userId._id;
            const date = dayjs(record.date, 'DD-MM-YYYY'); // replace with actual format
            console.log("Fetching attendance for user:", userId, "on date:", date);

            if (!date.isValid()) {
                message.warning("Invalid date format");
                return;
            }

            // Call the API with proper parameters
            const data = await fetchCampOffAttendance(userId, date);

            // Update state with fetched data
            setAttendanceData(data);

            // If you need to merge the fetched data with the record
            setCurrentRecord(prev => ({
                ...prev,
                ...data
            }));

        } catch (error) {
            message.error("Failed to fetch attendance data");
            console.error("Error fetching attendance:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleApprove = async () => {
        try {
            setIsLoading(true);

            if (!currentRecord?._id) {
                throw new Error("No record ID found");
            }

            const updateData = {
                ...record,
                status: "Approved", // Override status
                remark: remark,     // Add remark
            };
            await updateCampoffData(currentRecord._id, updateData,);
            message.success("Campus Off approved successfully");
            onSuccess?.();
            onClose();
        } catch (error) {
            message.error("Failed to approve camp off");
            console.error("Error approving camp off:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal

            visible={visible}
            onCancel={onClose}
            footer={null}
            width={950}
            centered={false} // Disable centered to use top positioning
            destroyOnClose={false} 
            className="custom-modal"
            style={{
                bottom: 20,
                top: 20,
                maxHeight: 'calc(100vh - 3  0px)', // Leaves 20px space at bottom
                margin: '0 auto',
                position: 'relative',
                // paddingBottom: 20 // Adds space inside modal at bottom
            }}
            bodyStyle={{
                // maxHeight: 'calc(90vh - 55px)',
                overflowY: 'auto',
                // padding: '20px',
                fontFamily: "inter, sans-serif",
            }}
            styles={{
                header: {
                    padding: "12px",
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#f1f5ffff",
                },
                content: {
                    padding: 0,
                    overflow: "hidden",
                },
            }}
            title={
                <div
                    style={{
                        color: "#4b5563",
                        fontFamily: "inter, sans-serif",
                        fontSize: "20px",
                        fontWeight: 500,
                    }}
                >
                    Approve CampusOff Details
                </div>
            }
        >
            <Spin spinning={isLoading}>
                {record && (
                    <div className="elements">
                        <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                            <Table
                                dataSource={[record]}
                                columns={[
                                    {
                                        title: 'Developer Name',
                                        key: "username",
                                        dataIndex: ['attendanceId', 'userId', 'username'],
                                        render: (_, record) => record.userId.username || "-",
                                        width: 150
                                    },
                                    {
                                        title: 'Date',
                                        key: "date",
                                        render: () =>
                                            dayjs(record.date, 'DD/MM/YYYY').isValid()
                                                ? dayjs(record.date, 'DD/MM/YYYY').format("DD/MM/YYYY")
                                                : "-",
                                        width: 120
                                    },
                                    {
                                        title: "Day",
                                        dataIndex: "date",
                                        key: "day",
                                        render: (date) => {
                                            if (!date) return "-";
                                            const parsedDate = dayjs(date, "DD/MM/YYYY");
                                            return parsedDate.isValid() ? parsedDate.format("dddd") : "-";
                                        }

                                    }
                                    ,
                                    {
                                        title: 'Clock In',
                                        key: "clockIn",
                                        dataIndex: ['attendanceId', 'clockIn'],
                                        render: (_, record) => record.clockIn,
                                        width: 120
                                    },
                                    {
                                        title: 'Lunch Start',
                                        key: "lunchStart",
                                        dataIndex: ['attendanceId', 'lunchStart'],
                                        render: (_, record) => record.lunchStart,
                                        width: 120
                                    },
                                    {
                                        title: 'Lunch End',
                                        key: "lunchEnd",
                                        dataIndex: ['attendanceId', 'lunchEnd'],
                                        render: (_, record) => record.lunchEnd,
                                        width: 120
                                    },
                                    {
                                        title: 'Clock Out',
                                        key: "clockOut",
                                        dataIndex: ['attendanceId', 'clockOut'],
                                        render: (_, record) => record.clockOut,
                                        width: 120
                                    },
                                    {
                                        title: 'Total Time',
                                        key: "totalTime",
                                        render: (_, record) => record.totalTime,
                                        width: 120
                                    },
                                    {
                                        title: "Status",
                                        key: "status",
                                        render: () => {
                                            const status = record.status;
                                            const style = statusStyles[status as keyof typeof statusStyles] || {
                                                background: '#e2e3e5',
                                                color: '#383d41'
                                            };
                                            return (
                                                <span
                                                    className="badge rounded-pill"
                                                    style={{
                                                        backgroundColor: style.background,
                                                        color: style.text,
                                                    }}
                                                >
                                                    {status}
                                                </span>
                                            );
                                        }
                                    },
                                ]}
                                pagination={false}
                                scroll={{ x: true }}
                                bordered
                                size="small"
                            />
                        </div>

                        <div style={{ marginTop: 16 }}>
                            <span style={{ fontWeight: '500' }}>Remark:</span>
                            <Input.TextArea

                                rows={3}
                                placeholder="Enter your remark (optional)"
                                style={{ marginTop: 8 }}
                                onChange={(e) => setRemark(e.target.value)}
                                value={remark}
                            />
                        </div>
                    </div>
                )}
                <Col
                    xs={24}
                    sm={24}
                    md={24}
                    xl={24}
                    xxl={20}
                    className="d-flex justify-content-end me-3 mt-3"
                >
                    <div className="button-wrapper">
                        <button
                            className="allcanclebutton"
                            onClick={onClose}
                            disabled={isLoading}
                        >
                            Cancel
                        </button>
                        <button className="allsubmitebutton "
                            style={{ width: "15vw" }}
                            onClick={handleApprove}
                            disabled={isLoading || record?.status === "Approved"}>
                            {isLoading ? "Aproving Campus Off..." : record?.status === "Approved"
                                ? "Approved"
                                : "Approve Campus Off"}
                        </button>
                    </div>
                </Col>
            </Spin>
        </Modal>
    );
}
